module.exports = __webpack_public_path__ + "img/cases-brand-hla-7.0ffd92b0.png";